import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
} from "reactstrap";

import BreadCrumb from "Components/Common/BreadCrumb";

import { capitalizeFirstLetter, handleValidDate, handleValidTime } from "helpers/common_helper";
import Loader from "Components/Common/Loader";

interface UserDetailpageProps {
    id: string;
    onBack: () => void;
    singleUserData: any;
    loading: boolean;
}

const UserDetailpage: React.FC<UserDetailpageProps> = ({ id, onBack, singleUserData, loading }) => {
const [modal, setModal] = useState(false);
const [isEdit, setIsEdit] = useState(false);
const toggle = () => {
  if (modal) setIsEdit(false); // Reset edit state if needed
  setModal(!modal);
};


    const userData = singleUserData;

    const handleBack = () => {
        onBack();
    };

    return (
        <>
        {loading? <Loader/> :
        <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
                     <Container fluid className="border pt-4 rounded-4  mb-3 ms-3 pe-4">
            
            <BreadCrumb
                title="User  Details"
                pageTitle={["User Report", "User", "Details"]}
            />
            {/* Header Section */}
            <Card className="mb-4 bg-primary-subtle">
                <CardBody>
                    <Row className="align-items-center">
                        <Col lg={8}>
                            <div className="d-flex align-items-center mb-3">
                                <div className="flex-grow-1">
                                    <div className="d-flex align-items-center mb-1">
                                        <Button
                                            className="btn btn-icon btn-sm btn-soft-dark me-2"
                                            onClick={handleBack}
                                        >
                                            <i className="ri-arrow-left-line"></i>
                                        </Button>
                                        <h3 className="mb-0">
                                            {
                                                userData?.first_name || userData?.last_name
                                                    ? `${capitalizeFirstLetter(userData?.first_name || "")} ${capitalizeFirstLetter(userData?.middle_name || "")} ${capitalizeFirstLetter(userData?.last_name || "")}`.trim()
                                                    : "N/A"
                                            }
                                        </h3>
                                    </div>
                                    <p className="text-muted mb-0">User ID :
                                        <strong className="text-primary">{` ${userData?.usercode}` || "  N/A"}</strong>
                                    </p>

                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-1 mt-1">
                                                <i className="ri-mail-line text-primary me-2"></i>
                                                {/* <strong className="form-label text-muted small"></strong> {userData?.email || "N/A"} */}
                                                <strong className="form-label text-muted small"></strong> {userData?.email || "N/A"}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-1 mt-1">
                                                <i className="ri-phone-line text-primary me-2"></i>
                                                {/* <strong className="form-label text-muted small"></strong> {userData?.mobile || "N/A"} */}
                                                <strong className="form-label text-muted small"></strong> {userData?.phone_no || "N/A"}
                                            </div>
                                        </Col>


                                    </Row>
                                </div>
                            </div>

                            <div className="row g-3">
                                <div className="col-auto m-0">
                                    <span className="text-muted">Created On:</span>
                                    <span className="ms-2 fw-medium">
                                        {userData?.created_at ? (
                                            <>
                                                {handleValidDate(userData?.created_at)}
                                                {", "}
                                                <small className="text-muted">
                                                    {handleValidTime(userData?.created_at)}
                                                </small>
                                            </>
                                        ) : "N/A"}

                                    </span>
                                </div>
                                <div className="col-auto m-0">
                                    <span className="text-muted">Last Updated On:</span>
                                    <span className="ms-2 fw-medium">
                                        {userData?.updated_at ? (
                                            <>
                                                {handleValidDate(userData?.updated_at)}
                                                {", "}
                                                <small className="text-muted">
                                                    {handleValidTime(userData?.updated_at)}
                                                </small>
                                            </>
                                        ) : "N/A"}

                                    </span>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} className="text-lg-end">
                            <div className="d-flex justify-content-lg-end">
                                <div className="avatar-lg rounded-circle bg-primary d-flex align-items-center justify-content-center">
                                    <i className="ri-user-line text-white" style={{ fontSize: '2rem' }}></i>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            <Row className="flex-grow-1">
                <Col lg={12} className="d-flex flex-column">

                    <Card className="flex-grow-1 d-flex flex-column">
                        <CardBody className="flex-grow-1">
                            <Row className="mb-2">
                                <Col lg={12}>
                                    {/* Additional Information Section */}
                                    <Card className="h-100">
                                        <CardHeader>
                                            <h5 className="mb-0">Additional Information</h5>
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label className="form-label text-muted small">Occupation</label>
                                                        {/* <p className="mb-0 fw-medium">{capitalizeFirstLetter(userData?.department) || "N/A"}</p> */}
                                                        <p className="mb-0 fw-medium">{capitalizeFirstLetter(userData?.occupation) || "N/A"}</p>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label className="form-label text-muted small">Status</label>
                                                        <p className="mb-0 fw-medium">
                                                            {userData?.status
                                                                ? userData?.status.toLowerCase()=="deactivated" || userData?.status.toLowerCase()=="inactive" ? "Inactive" : "Active"
                                                                : "N/A"}

                                                        </p>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label className="form-label text-muted small">Address</label>
                                                        {/* <p className="mb-0 fw-medium">{capitalizeFirstLetter(userData?.role) || "N/A"}</p> */}
                                                        <p className="mb-0 fw-medium">{capitalizeFirstLetter(userData?.curr_address) || "N/A"}</p>
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label className="form-label text-muted small">CPR ID</label>
                                                        {/* <p className="mb-0 fw-medium">{capitalizeFirstLetter(userData?.role) || "N/A"}</p> */}
                                                        <p className="mb-0 fw-medium">{capitalizeFirstLetter(userData?.cpr_id) || "N/A"}</p>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label className="form-label text-muted small">Gender</label>
                                                        {/* <p className="mb-0 fw-medium">{capitalizeFirstLetter(userData?.gender) || "N/A"}</p> */}
                                                        <p className="mb-0 fw-medium">{capitalizeFirstLetter(userData?.gender) || "N/A"}</p>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label className="form-label text-muted small">Verified</label>
                                                        <p
                                                            className="mb-0 fw-medium"
                                                            style={{
                                                                maxHeight: "100px",   // adjust height
                                                                maxWidth: "350px",    // adjust width
                                                                overflowY: "auto",    // vertical scroll
                                                                overflowX: "hidden",  // prevent horizontal scroll
                                                                whiteSpace: "normal", // allow wrapping
                                                                wordBreak: "break-word" // handle long words
                                                            }}
                                                        >
                                                            {userData?.isVerified
                                                                ? userData.isVerified : "N/A"}
                                                        </p>

                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label className="form-label text-muted small">Consent </label>
                                                        <p
                                                            className="mb-0 fw-medium"
                                                            style={{
                                                                maxHeight: "100px",   // adjust height
                                                                maxWidth: "350px",    // adjust width
                                                                overflowY: "auto",    // vertical scroll
                                                                overflowX: "hidden",  // prevent horizontal scroll
                                                                whiteSpace: "normal", // allow wrapping
                                                                wordBreak: "break-word" // handle long words
                                                            }}
                                                        >
                                                            {userData?.datausageconsent
                                                                ? userData.datausageconsent
                                                                : "N/A"}

                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            </Container>
        </div>}
        </>
    );
};

export default UserDetailpage;
